import { Nullable } from '@client/core/data/types';
import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';

/**
 * Describes a Workspace Company for purposes of displaying information on
 * various Investment Packet Reports.
 *
 * @see app/CompanyProfileResource.php
 */
export class CompanyInvestmentPacketData {
  constructor(
    public readonly ourCompany: Nullable<string>,
    public readonly ourMarket: Nullable<string>,
    public readonly ourExperiences: Nullable<string>,
    public readonly ourInvestmentStrategies: Nullable<string>,
    public readonly ourCompetitiveAdvantages: Nullable<string>,
    public readonly ourGoalsObjectives: Nullable<string>,
  ) {}
}

defineTransform(CompanyInvestmentPacketData, (_, { fromSnakeCaseKeys }) => {
  return {
    ...fromSnakeCaseKeys(),
  };
});
